export const WIFI_TABS = [
  ["dashboard", "Dashboard radiowy"], ["sites", "Bazy radiowe"], ["sectors", "Nadajniki i sektory"], ["links", "Mosty PTP"],
  ["devices", "Urządzenia"], ["models", "Katalog modeli"], ["audit", "Historia zmian"],
  ["subscribers", "Abonenci radiowi"], ["ip", "Adresacja IP"], ["planning", "Planowanie radiowe"], ["monitoring", "Monitoring"],
];
